/** Protocol §14: `min(30s, 1s * 2^attempt) ± 20% jitter`. */
const BASE_MS = 1_000;
const CAP_MS = 30_000;
const JITTER = 0.2;

/**
 * Jitter is not a nicety. Fifty thousand clients reconnecting in the same
 * 100 ms window after a gateway restart is the realistic way to take the box
 * down, so the spread is part of the protocol, not an optimisation.
 */
export function backoffMs(attempt: number): number {
  const raw = Math.min(CAP_MS, BASE_MS * 2 ** Math.max(0, attempt));
  const spread = raw * JITTER;
  return Math.round(raw - spread + Math.random() * spread * 2);
}
